import React, { FunctionComponent, useContext } from "react"
import { Typography, Button, Space } from "antd"
import LoginForm from "@components/forms/login"
import AuthContext from "@/context/auth.context"

const { Title } = Typography

const LoginPage: FunctionComponent = () => {
  const { authenticate, authenticateWithKeycloak, error, loading } = useContext(AuthContext)

  return (
    <div>
      <div
        style={{
          left: "50%",
          top: "50%",
          position: "absolute",
          transform: "translate(-50%, -50%)",
          padding: 40,
          borderRadius: 5,
          border: "1px solid black",
        }}
      >
        <Title style={{ textAlign: "center" }} level={5}>
          Login
        </Title>

        {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}

        <Space direction="vertical" style={{ width: '100%', marginBottom: 16 }}>
          <Button 
            type="primary" 
            onClick={authenticateWithKeycloak}
            loading={loading}
            style={{ width: '100%' }}
          >
            Login with AURIN SSO
          </Button>
          
          <div style={{ textAlign: 'center', margin: '10px 0' }}>
            <span>- or -</span>
          </div>
          
          <LoginForm onFinish={authenticate} loading={loading} />
        </Space>
      </div>
    </div>
  )
}

export default LoginPage
